let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cqBQJ")).then(() => parcelRequire('clu4g'));